<div class="mat-elevation-z5" style="padding: 20px; margin-right:20px">
  <div class="title remove-margin" >{{title}}</div>
  <dx-data-grid #datagriddx 
                [dataSource]="dataSource"
                [columns]="columns"
                [rowAlternationEnabled]="true"
                [columnAutoWidth]="true"
                (onCellClick)="onCellClick($event)"
                (onEditorPreparing)="onEditorPreparing($event)"
                (onEditingStart)="onEditingStart($event)"
                (onRowInserting)="onRowInserting($event)"
                (onRowUpdating)="onRowUpdating($event)"
                (onRowRemoving)="onRowRemoving($event)"
                (onInitNewRow)="onInitNewRow($event)"
                (onCellPrepared)="onCellPrepared($event)"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                [(selectedRowKeys)]="selectedRows">
    <dxo-paging [pageSize]="15"></dxo-paging>
    <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-editing [mode]="editMode"
                [allowUpdating]="allowUpdating"
                [allowAdding]="allowAdding"
                [useIcons]="true">
    </dxo-editing>        
    <dxo-selection
      mode="multiple"
      showCheckBoxesMode="always">
    </dxo-selection>
    <div *dxTemplate="let c of 'cellTemplateStatus'">
            
    </div>
    <div *dxTemplate="let data of 'dateCellTemplate'">
      <span>{{data.data.Date_Str}}</span>
    </div>
    <div *dxTemplate="let data of 'dateEditTemplate'">
        
        <span style="padding-left: 7px" *ngIf="(data.data.StatusId === 4 && !allowEditApproved) || (data.data.StatusId === 3 && !allowEditConfirmed) || ((data.data.CategoryId === 1 || data.data.CategoryId === 7) && data.data.StatusId === 2 && !allowEditUnconfirmed); else edit_date_select">{{data.data.Date_Str}}</span>
        <ng-template #edit_date_select>
          <dx-date-box 
            [value]="data.data.Date" [showClearButton]="true"  displayFormat="dd.MM.yyyy" (onFocusIn)="focusDate($event)" (onValueChanged)="onDateChanged($event, data)">
          </dx-date-box>
        </ng-template>
    </div>
    <div *dxTemplate="let data of 'projectEditTemplate'">
      <span style="padding-left: 7px" *ngIf="(data.data.StatusId === 4 && !allowEditApproved) || (data.data.StatusId === 3 && !allowEditConfirmed) || ((data.data.CategoryId === 1 || data.data.CategoryId === 7) && data.data.StatusId === 2 && !allowEditUnconfirmed); else edit_project_select">{{data.data.Project}}</span>
      <ng-template #edit_project_select>
        <dx-box direction="row"
          width="100%">
          <dxi-item  [ratio]="5">
            <dx-select-box 
                        [dataSource]="projectsDataSource"
                        displayExpr="ProjectDisplayName"
                        searchExpr="ProjectDisplayName"
                        valueExpr="ProjectId"
                        (onValueChanged)="onProjectValueChanged($event, data)"
                        [searchEnabled]="true"
                        [height]="35"
                        [showClearButton]="true"
                        [placeholder]="placeholderProjectSelectSearch"
                        [value]="data.data.CarrierProjectId"
                        (onFocusIn)="focusProject($event)">
            </dx-select-box>
          </dxi-item>
          <dxi-item [ratio]="1">
            <dx-button style="margin-left: 2px; margin-right: 2px" icon="search" [height]="35" (onClick)="showPopupProject(data.data.CarrierProjectId, data.data.CustomerId, data)"></dx-button>
          </dxi-item>
        </dx-box>
      </ng-template>

    </div>
    <div *dxTemplate="let data of 'transportCellTemplate'">
      <dx-button *ngIf="data.data.IsTransport" template="transportBtnTemplate" (onClick)="onOpenTransport($event, data)">
          <div *dxTemplate="let data of 'transportBtnTemplate'">  
            <fa-icon  [icon]="faTruckMoving" ></fa-icon>
          </div>  
      </dx-button>
    </div>
  </dx-data-grid>
</div>


<dx-popup
  class="popup"
  [width]="350"
  [height]="300"
  [showTitle]="true"
  title="Project"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  [(visible)]="popupVisible">
  <div *dxTemplate="let data of 'content'">
      <p>
        Customer:
        <dx-select-box [dataSource]="customerPopupDataSource"
          displayExpr="Name"
          valueExpr="CustomerId"
          [searchEnabled]="true"
          (onValueChanged)="onPopupCustomerChanged($event)"
          [value]="selectedCustomerIdPopup"
          [showClearButton]="true">
        </dx-select-box>
      </p>
      <p>
        Project:
        <dx-select-box [dataSource]="projectsPopupDataSource"
          displayExpr="ProjectDisplayName"
          searchExpr="ProjectDisplayName"
          valueExpr="ProjectId"
          [searchEnabled]="true"
          (onSelectionChanged)="onPopupProjectChanged($event)"
          [placeholder]="placeholderProjectSelectSearch"
          [value]="selectedProjectIdPopup"
          [showClearButton]="true">
        </dx-select-box>
      </p>
      <p>
        <dx-button text="Ok" (onClick)="onClickPopupSelectedProject($event)">

        </dx-button>
      </p>
  </div>
</dx-popup>

<dx-popup
  class="popup"
  [width]="1750"
  [height]="800"
  [showTitle]="true"
  [title]="titleEditTransport"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  [(visible)]="popupEditTransportVisible">
  <div *dxTemplate="let data of 'content'">
      <app-edit-transport #editTransport [(transport)]="transport" [employees]="employeeDataSource" [projects]="projectsDataSource" (refresh)="onRefresh()" ></app-edit-transport>
  </div>
</dx-popup>